import { isPremiumTier } from "@/lib/script-limits"

// No admin-boosted tier here on purpose (product decision 2026-09-20): being
// staff isn't a paid tier, so an admin/dev/moderator's draft limit follows
// their own real subscription, same as anyone else.
export const DRAFT_LIMITS = {
  guest: 1,
  free: 10,
  paid: 50,
} as const

export function getDraftLimitForAccount(input: {
  isGuest?: boolean
  subscriptionTier?: string | null
}) {
  if (input.isGuest) return DRAFT_LIMITS.guest
  if (isPremiumTier(input.subscriptionTier)) return DRAFT_LIMITS.paid
  return DRAFT_LIMITS.free
}
